export default "__VITE_ASSET__DOIM59Dd__"